// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'//引入element-ui
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import axios from 'axios'
import router from './router'
import store from './store'
import components from './components'
import md5 from 'js-md5'
import global_ from './common/upload.vue' 
import {filter} from '@/filter/commonfilter.js' //引入过滤器
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN';//引入中文文件
import 'font-awesome/css/font-awesome.min.css'
// import Share from 'vue-socail-share'
// Vue.use(Share)

Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(awesome);
Vue.prototype.$ajax = axios//全局axios
Vue.prototype.$md5 = md5;
Vue.prototype.Bstore=store;
Vue.prototype.BASEHOST="/v3";//打包发布
//Vue.prototype.BASEHOST="/v2";
Vue.prototype.TOKENID="";
Vue.prototype.GLOBAL = global_; 
filter(Vue); 
// Vue.prototype.Bstore=store;
Vue.prototype.Trim = function(value){
	if(value) return this.searchInput.replace(/(^\s*)|(\s*$)/g, ""); 
}
/*-----------------------加载vue组件----------------------------*/
const ComponentsPlugin = {
  install (Vue, options) {
    Object.keys(components).forEach((key) => {
      var name = key.replace(/(\w)/, (v) => v.toUpperCase())
      Vue.component(`z${name}`, components[key])
    })
  }
}
Vue.use(ComponentsPlugin)
Validator.addLocale(zh);

const config = { 
  locale: 'zh_CN',
  fieldsBagName: 'vee-fields',
  events:'blur',
  inject:true
};
Vue.use(VeeValidate,config);

const dictionary ={
  zh_CN:{
    messages:{}
  }
}
Validator.updateDictionary(dictionary);
// Validator.updateDictionary({
//   zh_CN: {
//       messages
//   }
// });
 
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js